<form [formGroup]="formGroup" (ngSubmit)="submitSearchByName()">
  <div id="searchByName" class="column twelve lg-twelve pad-top-20">
    <div class="column twelve pad-bottom-5">
      <ds-form-control-container
        [labelText]="'Shop Name'"
        [control]="formGroup.controls['shopName']"
        [validateOnSubmit]="submitted"
      >
        <input
          data-cy="drpSearchByNameShopName"
          type="text"
          id="shop-name"
          class="fill"
          formControlName="shopName"
          required
        />
        <ds-form-control-message
          [control]="formGroup.controls['shopName']"
          [validateOnSubmit]="submitted"
        >
        </ds-form-control-message>
      </ds-form-control-container>
    </div>
    <div class="column six pad-bottom-5 pad-right-10">
      <ds-form-control-container
        [labelText]="'City'"
        [control]="formGroup.controls['city']"
        [validateOnSubmit]="submitted"
      >
        <input
          type="text"
          data-cy="drpSearchByNameCity"
          id="city"
          class="fill"
          formControlName="city"
        />
        <ds-form-control-message
          [control]="formGroup.controls['city']"
          [validateOnSubmit]="submitted"
        >
        </ds-form-control-message>
      </ds-form-control-container>
    </div>
    <div class="column six pad-bottom-5">
      <ds-form-control-container
        [labelText]="'State'"
        [control]="formGroup.controls['state']"
        [validateOnSubmit]="submitted"
      >
        <select data-cy="drpSearchByNameState" id="state" class="icon fill" formControlName="state">
          <option value=""></option>
          @for (state of states; track state) {
            <option value="{{ state }}">{{ state }}</option>
          }</select
        ><span class="icon-chevron-down"></span>
        <ds-form-control-message
          [control]="formGroup.controls['state']"
          [validateOnSubmit]="submitted"
        >
        </ds-form-control-message>
      </ds-form-control-container>
    </div>
    <div class="column six pad-right-10">
      <ds-form-control-container
        [labelText]="'ZIP Code'"
        [control]="formGroup.controls['zip']"
        [validateOnSubmit]="submitted"
      >
        <input
          data-cy="drpSearchByNameZip"
          type="text"
          id="zip"
          class="fill"
          formControlName="zip"
        />
        <span id="icon-find" class="icon-find"></span>
        <ds-form-control-message
          [control]="formGroup.controls['zip']"
          [validateOnSubmit]="submitted"
        >
        </ds-form-control-message>
      </ds-form-control-container>
    </div>
    <div class="column six">
      <button
        data-cy="drpSearchByNameButton"
        ds-button
        class="column twelve input-offset"
        type="Submit"
        [disabled]="!formGroup.valid"
      >
        Search
      </button>
    </div>
  </div>
</form>
